import { InsertComment } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import React from "react";
import CustomTextField from "src/components/shared/Custom/TextField";
import { IFormComponent } from "src/hooks/useForm";

export default function Observacion({handleFormChange, fields, name}) {
  return (
    <Stack gap={1}>
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <InsertComment sx={{ color: "#1B23BE" }} />
        <Typography fontSize={18} fontWeight={400} color={"black"}>
          Observación
        </Typography>
      </Stack>
      <CustomTextField
        name={name}
        value={fields[name]}
        onChange={(e) => handleFormChange(e.target)}
        placeholder="Escribe un comentario"
        sx={{ minWidth: "240px", width: "100%" }}
      ></CustomTextField>
    </Stack>
  );
}
